import { Component, ElementRef, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { CommonService } from '../common-service';
import { MarkdownService } from '../markdown-service';
import { QuestionService } from '../question.service';
import { SanitizationService } from '../sanitization.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-faq-detail',
  templateUrl: './faq-detail.component.html',
  styleUrl: './faq-detail.component.scss'
})
export class FaqDetailComponent {
  question: any='';
  answer: any='';
  upVotes: number = 0;
  downVotes: number = 0;
  relatedQuestions: any[] = [];
  savedAnswer: string | null | undefined;
  topratedQuestion: any;
  questionId!: number;
  likeCounts: { [key: number]: number } = {};
  dislikeCounts: { [key: number]: number } = {};
  thumbsupClicked: any;
  thumbsdownClicked: any;
  selectedcollection!: any;
  isEditMode: boolean=false;
  loader: boolean=true;
  role:any="";
  similarQuestions: any[] = [];
  availableCollections: any;
  collection_id: any;
  totalrecords= 0;
  rows: number = 5;
  first: number = 0;
  pagenumber: number = 1;
  showmodal=false
  modalloader=true
  mappedAnswer: any;
  mappedQuestion: any;
  dialogheader="Map answer to new question"
  mappedId!: number;
  correctanswer: any='';
  maploader: boolean=false;
  searchkey:any=''
  filteredQuestions:{question:string}[] = [];
  isotherQnEditMode=false;
  saved_answer = {
    documentReferred: {
      documents: [
        {
          "document_id": 0,
          "document_name": ''
        }]
    }
  }
  OriginalQnId: string | null;
  askedQN: any;

  og_question: any;
    constructor(private route: ActivatedRoute,private sanitizer: DomSanitizer,private api:CommonService,private markdownService: MarkdownService,
    private quesService: QuestionService,private router: Router, private sanitizeService:SanitizationService,
    private messageService: MessageService
  ) {     
    this.OriginalQnId=localStorage.getItem('OC_ID');
    this.api.getMethod('get-collections/v2').subscribe((data: any) => {
      this.availableCollections = data;
      this.selectedcollection = localStorage.getItem('selectedCollection') ? localStorage.getItem('selectedCollection') : data[0].collectionName;})  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.questionId=params['questionid'],
      this.og_question= params['og_question'],
      console.log("og_question::", this.og_question);
      
    });
    this.fetchCollections();
    this.fetchQuestionById();
    this.fetchVerionsofAns();
    this.role = localStorage.getItem('role');
  }
  navigateTosavedanswer(){
    this.router.navigate(["/saved-answer"])
  }

  downloadAnswer(answer:string |SafeHtml) {
    let content: string;
    if (typeof answer === 'string') {
       content = answer.replace(/\\n/g, '\n').replace(/\\t/g, '\t');
    } else {
      content = this.sanitizer.sanitize(1, answer) || '';
    }

    const blob = new Blob([content], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'downloadedAnswer.txt';  // Default filename
    a.click();
    window.URL.revokeObjectURL(url);
  }
  getFeedbackCounts(answerId: number): void {
    this.quesService.getFeedback(answerId).subscribe(data => {
      this.likeCounts[answerId] = data.data.likes || 0;
      this.dislikeCounts[answerId] = data.data.dislikes || 0;
    });
  }
  thumbsup(){
    let id=this.questionId
    this.quesService.updateFeedback(id, true).subscribe(response => {
      if (response.code == 200) {
        this.thumbsupClicked = true;
        this.thumbsdownClicked = false;
        this.likeCounts[id] = (this.likeCounts[id] || 0) + 1;
        if (this.dislikeCounts[id] > 0) {
          this.dislikeCounts[id] -= 1;
        }
        this.getFeedbackCounts(id)
      }
    });
   
  }
  thumbsdown(){
    let answerId=this.questionId
    this.quesService.updateFeedback(answerId, false).subscribe(response => {
      if (response.code === 200) {
        this.thumbsdownClicked = true;
        this.thumbsupClicked = false;
        this.dislikeCounts[answerId] = (this.dislikeCounts[answerId] || 0) + 1;
        if (this.likeCounts[answerId] > 0) {
          this.likeCounts[answerId] -= 1;
        }
        this.getFeedbackCounts(answerId)
      }
    });
  }
  fnincreaseViewCount(){
    this.quesService.increaseViewCount(this.questionId).subscribe({next:(data)=>{
      this.fetchtopViewedQuestion()
    }});
  }
    fetchQuestionById(){
      this.loader=true      
      let Payload: any={
        "id": this.questionId
      }

      if(this.OriginalQnId){
        Payload.oc_id=this.OriginalQnId
      }

      this.quesService.getQnById(Payload).subscribe({next:(res)=>{
        this.question=res.data.question
        this.answer=res.data.answer;
        this.saved_answer=res.data;
        this.askedQN=res.data.original_question;
        this.loader=false
        this.getFeedbackCounts(this.questionId)
      },
       error:(err)=> {
        this.messageService.add({ severity: 'error', detail: err.error.detail});
        this.loader=false; }
    });
    }
    getFilteredDocuments() {
      return this.saved_answer.documentReferred.documents.filter((doc: any) => doc.document_name && doc.document_name.trim() !== '');
    }
  fetchtopViewedQuestion(){
    this.quesService.getTopViewedQuestions(10,this.selectedcollection).subscribe({
      next:(res:any)=>{
        // this.topratedQuestion= res.data;
      },
      error:(error:any)=>{
        this.topratedQuestion=[]
      }
   })
  }
  fetchVerionsofAns(){
    this.quesService.getversionAns(this.questionId).subscribe({
      next:(res:any)=>{
        this.topratedQuestion= res.data;
      },
      error:(error:any)=>{
        this.topratedQuestion=[]
      }
   })
  }
  sanitizeMessage(message: string): SafeHtml {
    return this.sanitizeService.sanitizeMessage(message);
   }
  useThisAnswer(data:any){
     let payload={
      "id": this.questionId,
      "question": this.question,
      "answer": data.answer,
      "update": "answer"
  }
  this.loader=true
    this.quesService.updatequesAnswer(payload).subscribe({
      next:(data:any) => {
        this.messageService.add({ severity: 'success', detail: data.message});
        this.loader=false
       location.reload();
        localStorage.setItem('answerUpdated', 'true'); 
      },
      error:(err)=> {
        this.messageService.add({ severity: 'error', detail: err.error.details.answer.message});
        this.loader=false;       
      },
    })
  }
  
  
  getAbsoluteUrl(questionId: number): string {
    const tree = this.router.createUrlTree(['/faq'], { queryParams: { questionid: questionId } });
    return `${window.location.origin}${this.router.serializeUrl(tree)}`;
  }

  getQuAns(questionId: number) {
    const url = this.getAbsoluteUrl(questionId);
    window.open(url, '_blank');
  }
  editQues(){
   this.isEditMode=true
      }
  cancelChange(){
    this.isEditMode = false;
    this.fetchQuestionById();
  }
 
  savechanges(){
  
   let payload={
      "id": this.questionId,
      "question": this.question,
      "answer": this.answer,
      "update": "both"
  }
  this.loader=true
    this.quesService.updatequesAnswer(payload).subscribe({
      next:(data:any) => {
        this.messageService.add({ severity: 'success', detail: data.message});
        this.isEditMode=false
        this.loader=false
        this.fetchQuestionById();
        localStorage.setItem('answerUpdated', 'true'); 
      },
      error:(err)=> {
        this.messageService.add({ severity: 'error', detail: err.error.detail});
      },
    })
  }
  onPageChange(event:any) {
    this.loader=true
    this.first = event.first;
    this.pagenumber = event.page+1;
    this.getsimilarmapedQn()
  }

  getsimilarmapedQn(){
    this.quesService.getSimilarQuestions(this.collection_id, this.questionId,this.pagenumber,5).subscribe({
      next:(data:any) => {
        this.loader=false;
        // this.similarQuestions = data.data.questions;
         const documents= data.data.questions;      
       this.similarQuestions = documents.sort((a: any, b: any) => {
      return new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime();
    });
        this.totalrecords = data?.data.totalQuestionCount
      },
      error:(err) => {
        console.error('Error fetching similar questions:', err);
      }
  });
  }
   fetchCollections(): void {
    this.api.getMethod('get-collections/v2').subscribe((data: any) => {
      this.availableCollections = data;
      this.selectedcollection = localStorage.getItem('selectedCollection') ? localStorage.getItem('selectedCollection') : data[0].collectionName;
      let collection=this.availableCollections.find((x:any)=>x.collectionName==this.selectedcollection);
      if (collection) {
        this.collection_id=collection.collection_id 
             setTimeout(()=>{
        this.getsimilarmapedQn();
        this.fnincreaseViewCount();
       },1000)
    };
  })
}
cleanHtml(text: string): string {
  return this.sanitizeService.cleanHtml(text)
}
OpentomapAnswer(){
  this.correctanswer='',
  this.searchkey=''
  this.showmodal = true;
  this.modalloader=true
  this.mappedQuestion=this.question;
  this.mappedAnswer=this.answer
  this.mappedId=this.questionId
   this.modalloader=false
}
mapsearch(event:any){
  let query = event.query 
  if (this.selectedcollection && query.length >1) {
  let payload={
    "collectionName": this.selectedcollection,
    "question": query,
    "filter": [{"answer_approved": ["eq", 1]},{"id": ["notIn", [this.mappedId]]}],
    "attributes": ["id","question"]
}
  this.quesService.faqssearch(payload).subscribe({
    next: (res: any) => {
       this.filteredQuestions = res.data.map((q:any) => ({question: this.cleanHtml(q.question),id: q.id}));
    },
    error: (err: any) => {
      console.error('Error searching questions:', err);
    }
  });
} else {
  this.filteredQuestions = [];
}

}
onSelectmap(event:any)
{ 
  this.questionId = event.value.id;
  this.performmapSearch()
}
performmapSearch(){
  if (this.selectedcollection && this.questionId) {
    this.maploader = true;
   
    this.quesService.getQnById(this.questionId).subscribe({next:(res)=>{
      // this.question=res.data.question
      this.correctanswer=res.data.answer
      this.maploader=false
    },
    error: (err: any) => {
      this.loader = false;
      console.error('Error fetching question details:', err);
    }});
}
}
mapAnswer(){
  let collectionId = this.availableCollections.find((x: any) => x.collectionName === this.selectedcollection)?.collection_id;
  let payload = {
    "collectionName": this.selectedcollection,
    "question_id": this.mappedId,
    "new_mapping": this.questionId,
    "question": this.searchkey.question,
    "collection_id": collectionId
  }
  this.modalloader=true
  this.quesService.updateMappedAnswer(payload).subscribe({next:(response)=>{
    this.modalloader=false
    this.showmodal=false
    this.messageService.add({ severity: 'success', detail: response.message })
    this.fetchQuestionById()
      this.router.navigate([], {
      queryParams: { questionid: this.questionId },
      queryParamsHandling: 'merge',
    });
  },
  error: (err: any) => {
    this.modalloader = false;
    this.messageService.add({ severity: 'error', detail: err.error.message });
    this.showmodal=false
    console.error('Error updating mapped question', err);
  }});
}
Onclose(){this.showmodal=false}
onDialogHideaddcollection(){this.showmodal=false}
editotherQn(index: number) {
  this.similarQuestions[index].originalQuestion = this.similarQuestions[index].question;
  
  // Enable edit mode
  this.similarQuestions[index].isotherQnEditMode = true;
}
updatemapQn(question: any): void {
  const payload = {
    "question": question.question
  }
  this.api.putMethod(`canned/${question.id}`, payload).subscribe({
    next: (response) => {
      question.isotherQnEditMode = false;
      this.messageService.add({ severity: 'success', detail: response.message });
    },
    error: (err: any) => {
      this.messageService.add({ severity: 'error', detail: err.error.message });
      console.error('Error updating mapped question', err);
    }
  });
}
cancelEditQn(index:number){
  this.similarQuestions[index].question = this.similarQuestions[index].originalQuestion;

  this.similarQuestions[index].isotherQnEditMode = false;
}
navigateToDoc(doc:any){
  const dataToPass = { documentId: doc.document_id, collectionId: this.collection_id };
  this.api.setData(dataToPass);
  this.router.navigate(['collection', this.selectedcollection, 'document', doc.document_name])
}
}

  
